// extracted by mini-css-extract-plugin
export default {"document":"PDFViewer_document__+4Hru","page":"PDFViewer_page__Lqn5m"};